module.exports = __webpack_public_path__ + "static/img/Icon2.9f940e5f.svg";